// extracted by mini-css-extract-plugin
export default {"listheader":"MessageListHeader_listheader__wADSH"};